// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-Y26","left":"styles_left__2r11i"};